import { Component, OnInit, ViewChild } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";
import { SchemaService } from "../../services/schema.service";
import { detailExpand } from "../../animations";

@Component({
  selector: "formly-array-type",
  template: `
    <div>
      <legend *ngIf="to.label">{{ to.label }}</legend>
      <p *ngIf="to.description">{{ to.description }}</p>

      <div
        class="alert alert-danger"
        role="alert"
        *ngIf="showError && formControl.errors"
      >
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>

      <div *ngFor="let field of field.fieldGroup; let i = index" class="row">
        <div class="flex ion-align-items-center">
          <formly-field class="h-spacer" [field]="field"></formly-field>
          <ion-button
            size="small"
            color="danger"
            fill="clear"
            type="button"
            (click)="remove(i)"
          >
            <ion-icon name="close-circle-outline"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div class="d-flex flex-row-reverse">
        <ion-button
          [disabled]="
            form.disabled ||
            (field &&
              field.model &&
              field.model.length &&
              (!field.model[field.model.length - 1] ||
                field.model[field.model.length - 1].invalid))
          "
          size="small"
          color="primary"
          fill="clear"
          type="button"
          (click)="add()"
          >+ Add</ion-button
        >
      </div>
    </div>
  `,
  animations: [detailExpand],
  styles: [
    `
      .bordered {
        border: 1px solid rgba(var(--ion-color-dark-rgb), 0);
        padding: 6px;
      }
      .bordered.show {
        border: 1px solid rgba(var(--ion-color-dark-rgb), 0.25);
      }
    `,
  ],
})
export class ArrayTypeComponent extends FieldArrayType {
  constructor(public service: SchemaService) {
    super();
    // /console.log(this.field)
  }
  logify(e) {
    console.log(e);
  }
}

/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
